import React from "react";
import { Box, Typography, Paper, List, ListItem, ListItemText, Divider } from "@mui/material";
import Grid from "./utils/CompatGrid";
import { LABEL_SIZE_PRESETS, PAPER_TYPES, BARCODE_TYPES } from "./utils/labelSizes";

const SettingsPage = () => (
  <Box>
    <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
      Settings
    </Typography>
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Paper elevation={1} sx={{ p: 2, borderRadius: 3 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Available Label Sizes
          </Typography>
          <List dense>
            {LABEL_SIZE_PRESETS.map((s) => (
              <ListItem key={s.key} disableGutters>
                <ListItemText primary={s.label} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper elevation={1} sx={{ p: 2, borderRadius: 3 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Paper Types
          </Typography>
          <List dense>
            {PAPER_TYPES.map((p) => (
              <ListItem key={p.value} disableGutters>
                <ListItemText primary={p.label} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Grid>
      <Grid item xs={12} md={4}>
        <Paper elevation={1} sx={{ p: 2, borderRadius: 3 }}>
          <Typography variant="subtitle1" fontWeight={600} gutterBottom>
            Barcode Types
          </Typography>
          <List dense>
            {BARCODE_TYPES.map((b) => (
              <ListItem key={b.value} disableGutters>
                <ListItemText primary={b.label} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Grid>
    </Grid>
    <Divider sx={{ my: 3 }} />
    <Typography variant="body2" color="text.secondary">
      Fonts used across the designer follow Google Fonts Unicode families (Noto Sans, Noto Sans Devanagari, Mukta,
      Hind, Roboto) to correctly render both English and Marathi text.
    </Typography>
  </Box>
);

export default SettingsPage;
